import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { UTILS } from 'src/app/entities/Utils';

export interface AlertProp{
  view: boolean,
  valClass: string,
  title: string,
  autoHidde: boolean,
  delay: number
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {


  listAlert : AlertProp[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  public getTopPosition(index: number): number{
    try {
      if(index == 0){
        return 10;
      } else {
        let top = $("#" + (index -1) + '_alert').offset()?.top;
        top! +=  $("#" + (index -1) + '_alert').height()!;
        return top! + 15;
      }
    } catch (error) {
      
    }
    return 10;
  }

  public addAlert(alert: AlertProp){
    this.listAlert.push(alert);
  }

  public removeAlert(index: number){
    this.listAlert.splice(index, 1);
  }

}
